import general from '../../utils/general';
import { useState } from 'react';
import { translations, LanguageKeys } from './translation';

export const useController = () => {
    const [account, setAccount] = useState<any>({
        name: '',
        email: '',
        password: '',
        passwordcheck: '',
        preferredLanguage: general.getBrowserLanguage() === 'PTBR' ? 'PTBR' : 'EN',
        timezone: general.getTimezone(),
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [currentLanguage, setCurrentLanguage] = useState<LanguageKeys>((general.getBrowserLanguage() == 'PTBR' ? 'PTBR' : 'EN') as LanguageKeys);

    const handleChange = (event: any) => {
        setAccount({...account, [event.target.name]: event.target.value});
    }

    const checkForObligatoryFields = () => {
        let blocked = false;
        let message = translations[currentLanguage].requiredFieldsMessage;

        if(account.name === ''){
            blocked = true;
            message += `${translations[currentLanguage].name}, `;
        }

        if(account.email === ''){
            blocked = true;
            message += 'Email, ';
        }

        if(account.password === ''){
            blocked = true;
            message += `${translations[currentLanguage].password}, `;
        }

        if(account.passwordcheck === ''){
            blocked = true;
            message += `${translations[currentLanguage].confirmPassword}, `;
        }

        message = message.substring(0, message.length - 2) + '.';

        return {blocked, message};
    }

    const checkPassword = () => {
        if(account.password !== account.passwordcheck){
            return false;
        }
        return true;
    }

    const createAccount = (e: any) => {
        e.preventDefault();
        const checkFields = checkForObligatoryFields();
        const checkPass = checkPassword();

        if(checkFields.blocked){
            general.toast.error(checkFields.message);
            return;
        }
        if(!checkPass){
            general.toast.error(translations[currentLanguage].passwordMismatch);
            return;
        }

        try{
            setLoading(true);
            general.api.post('account/create', account)
            .then((response: any) => {
                if(response.data.status === 409)
                    general.toast.error(response.data.message);
                else{
                    let accountData = response.data.data.account;
                    accountData.token = response.data.data.token;
                    localStorage.setItem("token", response.data.data.token);
                    localStorage.setItem("account", JSON.stringify(response.data.data.account));
                    general.toast.success(translations[currentLanguage].accountCreated);
                    general.GoToRoute('/')
                }
            })
            .catch((error: any) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
        }
        catch(err){
            setLoading(false);
            console.log(err);
        }
    }

    return {
        general,
        createAccount,
        handleChange,
        currentLanguage,
        account,
        loading,
    }
}

export default useController;